import { render, staticRenderFns } from "./DeviceRegisterView.vue?vue&type=template&id=1d70aad6&"
import script from "./DeviceRegisterView.vue?vue&type=script&lang=js&"
export * from "./DeviceRegisterView.vue?vue&type=script&lang=js&"
import style0 from "./DeviceRegisterView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCol,VImg,VRow,VSheet})
